import AddIcon from "@mui/icons-material/Add";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import RemoveIcon from "@mui/icons-material/Remove";
import { Box, Button, IconButton, MenuItem, Select } from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import lineBreak from "../../../utils/lineBreak";

export default function OptionResponse() {
  const { t } = useTranslation();
  const [jsonFinal, setJsonFinal] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [positive, setPositive] = useState<string>("");
  const [negative, setNegative] = useState<string>("");
  const [iten, setIten] = useState<string>("");
  const [itens, setItens] = useState<any[]>([]);
  const [responseType, setResponseType] = useState<string>("");

  const generate = () => {
    const concat = lineBreak(description);
    let jsonGerado: any = {};

    if (responseType === "positiveNegative") {
      jsonGerado = {
        generic: [
          {
            response_type: "text",
            values: [
              {
                text_expression: {
                  concat,
                },
              },
            ],
            selection_policy: "sequential",
          },
          {
            options: [
              {
                label: positive,
                value: {
                  input: {
                    text: positive,
                  },
                },
              },
              {
                label: negative,
                value: {
                  input: {
                    text: negative,
                  },
                },
              },
            ],
            response_type: "option",
            repeat_on_reprompt: true,
          },
        ],
      };
    } else if (responseType === "schedule") {
      jsonGerado = {
        generic: [
          {
            response_type: "text",
            values: [
              {
                text_expression: {
                  concat,
                },
              },
            ],
            selection_policy: "sequential",
          },
          {
            options: [
              {
                label: positive,
                value: {
                  input: {
                    text: responseType,
                  },
                },
              },
              {
                label: negative,
                value: {
                  input: {
                    text: t("transformJson.negativeResponse"),
                  },
                },
              },
            ],
            response_type: "option",
            repeat_on_reprompt: true,
          },
        ],
      };
    } else if (responseType === "itens") {
      jsonGerado = {
        generic: [
          {
            response_type: "text",
            values: [
              {
                text_expression: {
                  concat,
                },
              },
            ],
            selection_policy: "sequential",
            repeat_on_reprompt: false,
          },
          {
            response_type: "option",
            repeat_on_reprompt: true,
            options: itens,
          },
        ],
      };
    }
    setJsonFinal(JSON.stringify(jsonGerado, null, 2));
  };

  const clear = () => {
    setDescription("");
    setPositive("");
    setNegative("");
    setIten("");
    setItens([]);
    setResponseType("");
    setJsonFinal("");
  };

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Select
          displayEmpty
          defaultValue=""
          value={responseType}
          labelId="typeJsonSelect"
          id="handleTypeJsonSelect"
          sx={{ height: 40, width: { xs: "100%", sm: "50%", md: "33%" } }}
          onChange={(type: any) => {
            setResponseType(type.target.value);
          }}
        >
          <MenuItem disabled value="">
            <em>{t("transformJson.typeResponse")}</em>
          </MenuItem>
          <MenuItem value="positiveNegative">
            {t("transformJson.positiveNegative")}
          </MenuItem>
          <MenuItem value="schedule">{t("transformJson.schedule")}</MenuItem>
          <MenuItem value="itens">{t("transformJson.itens")}</MenuItem>
        </Select>
      </Grid>

      {responseType !== "" ? (
        responseType === "itens" ? (
          <Grid size={12} container spacing={2}>
            <Grid size={12}>
              <TextField
                fullWidth
                size="small"
                label={t("transformJson.description")}
                variant="outlined"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Grid>
            <Grid size={12}>
              <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                <TextField
                  fullWidth
                  size="small"
                  label={t("transformJson.positive")}
                  variant="outlined"
                  value={iten}
                  onChange={(e) => setIten(e.target.value)}
                />
                <IconButton
                  color="primary"
                  aria-label="add"
                  disabled={iten === ""}
                  onClick={() => {
                    setItens([
                      ...itens,
                      { label: iten, value: { input: { text: iten } } },
                    ]);
                    setIten("");
                  }}
                >
                  <AddIcon />
                </IconButton>
              </Box>
            </Grid>
            <Grid container>
              {itens.map((aux: any, index: number) => {
                return (
                  <Grid
                    container
                    key={`${aux.label || "item"}-${index}`}
                    sx={{ marginBottom: 2 }}
                  >
                    <Grid size={3}>
                      <TextField
                        fullWidth
                        size="small"
                        id="outlined-basic"
                        label={t("transformJson.text")}
                        variant="outlined"
                        value={aux.label || ""}
                        onChange={(e) => {
                          const newArr = [...itens];
                          newArr[index].label = e.target.value;
                          newArr[index].value.input.text = e.target.value;
                          setItens(newArr);
                        }}
                      />
                    </Grid>
                    <Grid size={1} sx={{ marginLeft: 2 }}>
                      <IconButton
                        color="primary"
                        aria-label="add"
                        onClick={(e) => {
                          const newArr = [...itens];
                          newArr.splice(index, 1);
                          setItens(newArr);
                        }}
                      >
                        <RemoveIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        ) : (
          <Grid container size={12} spacing={2}>
            <Grid size={12}>
              <TextField
                fullWidth
                size="small"
                label={t("transformJson.description")}
                variant="outlined"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                fullWidth
                size="small"
                label={t("transformJson.positive")}
                variant="outlined"
                value={positive}
                onChange={(e) => setPositive(e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                fullWidth
                size="small"
                label={t("transformJson.negative")}
                variant="outlined"
                value={negative}
                onChange={(e) => setNegative(e.target.value)}
              />
            </Grid>
          </Grid>
        )
      ) : null}

      <Grid size={12} sx={{ display: "flex", gap: 1 }}>
        <Button
          variant="contained"
          disabled={
            !(
              description !== "" &&
              (itens.length > 0 || (positive !== "" && negative !== ""))
            )
          }
          onClick={generate}
        >
          {t("button.Generate")}
        </Button>
        <Button variant="contained" onClick={clear}>
          {t("button.Clean")}
        </Button>
      </Grid>
      {jsonFinal !== "" && (
        <Grid size={12} sx={{ flexDirection: "column" }}>
          <pre
            style={{
              wordWrap: "break-word",
              width: "100%",
              whiteSpace: "pre-wrap",
            }}
          >
            {jsonFinal}
          </pre>
          <Button
            variant="contained"
            onClick={() => navigator.clipboard.writeText(jsonFinal)}
            startIcon={<ContentCopyIcon />}
          >
            {t("button.Copy")}
          </Button>
        </Grid>
      )}
    </Grid>
  );
}
